import React from "react";
import "../../pages/Surveys/style.css";
import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Label, Input, Button } from "reactstrap";
import { useState, useEffect, useRef, useMemo } from "react";
import { GetProjectBeneficiaries } from "../../services/Api";
import { SUCCESS_RESULT } from "../../Constants";
import { FaTimes, FaEdit, FaPlus } from "react-icons/fa";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useHistory } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { Component } from "ag-grid-community";

const BeneficiaryList = (props) => {
  const history = useHistory();
  const [is_processing, setProcessing] = useState(false);
  const { data } = (props.location && props.location.state) || {};
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);

  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);

  useEffect(() => {
    fetch_data();
    return () => {};
  }, []);

  const fetch_data = () => {
    setProcessing(true);

    GetProjectBeneficiaries(data)
      .then((res) => {
        setProcessing(false);
        //gridRef.current.api.showLoadingOverlay();
        if (res.status == 200) {
          var response = res.data;
          console.log(JSON.stringify(res.data));
          if (response.status == SUCCESS_RESULT) {
            let _data = [];
            if (response.data?.length < 1) {
              alert("No Beneficiary Data");
              return;
            }
            response.data?.map((p) => {
              let ben = JSON.parse(p.beneficiary_details);
              if (ben == null) {
                return;
              }

              _data.push({
                ben_id: p.ben_id,
                created_at: p.created_at,
                visit_id: p.visit_id,
                service_request_id: p.service_request_id,
                visit_count: p.visit_count,
                name:
                  ben.first_name + " " + ben.middle_name + " " + ben.last_name,
                criteria: ben.criteria,
                phone: ben.telephone,
                gender: ben.gender,
                camp: ben.camp,
                card_label: p.card_label,
              });
            });

            setRowData(_data);
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        } else {
          {
            cogoToast.error(res.message, {
              hideAfter: 5,
            });
          }
          cogoToast.error(res.message, {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
        setProcessing(false);
        console.log(err);
        cogoToast.error(err, {
          hideAfter: 5,
        });

        cogoToast.error("Something went wrong, please Try again.", {
          hideAfter: 5,
        });
      });
  };

  return (
    <div>
      <h1>
        {" "}
        BENEFICARY LIST {data.project_name} - {data.component_name}
      </h1>
      {/* {JSON.stringify(rowData)} */}
      <div className="ag-theme-alpine">
        <AgGridReact
          suppressMenuHide={true}
          ref={gridRef}
          //   overlayLoadingTemplate={
          //     '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
          //   }

          overlayLoadingTemplate={
            '<span className="ag-overlay-loading-center"> loading data...</span>'
          }
          onGridReady={(params) => {
            setGridApi(params.api);
            params.api.showLoadingOverlay();
          }}
          rowData={rowData}
          domLayout={"autoHeight"}
          animateRows={true}
          onRowDoubleClicked={(e) => console.log(e.data)}
          pagination={true}
          paginationPageSize={100}
          defaultColDef={defaultColDef}
          resizable={true}
          enableCellTextSelection={true}
          suppressCellSelection={true}
          columnDefs={[
            {
              headerName: "#",
              filter: false,
              maxWidth: 70,
              sortable: true,
              valueFormatter: function (params) {
                return `${parseInt(params.node.id) + 1}`;
              },
            },

            {
              headerName: "Name",
              field: "name",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Phone",
              field: "phone",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Sex ",
              field: "gender",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Created At ",
              field: "created_at",
              sortable: true,
              filter: true,
            },

            {
              headerName: "Camp",
              field: "camp",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Criteria",
              field: "criteria",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Card",
              field: "card_label",
              sortable: true,
              filter: true,
            },
          ]}
        ></AgGridReact>
      </div>{" "}
    </div>
  );
};

export default BeneficiaryList;
